import Nullstack from 'nullstack';
export default function IconLetterCaseUpper({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-letter-case-upper",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
  }), "   ", Nullstack.element("path", {
    d: "M3 13h7"
  }), "   ", Nullstack.element("path", {
    d: "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
  }), "   ", Nullstack.element("path", {
    d: "M14 13h7"
  }), " ");
}